/**
 * LegalDocumentShell — public-facing chrome for the /privacy and /terms pages.
 *
 * User journey: someone clicks "Privacy Policy" or "Terms of Service" from
 * the payment footer (or types the URL directly). They're almost never
 * authenticated here, so this is standalone — Aelita brand header, no
 * sidebar, no app nav. The document itself renders inside an <iframe> so
 * the vendored Termly export's own styling stays fully isolated from the
 * rest of the app and can be swapped wholesale without touching React.
 *
 * A shared override stylesheet (public/legal-doc-overrides.css) is linked
 * directly into privacy.html/terms.html — see that file for why styling
 * lives there instead of here.
 */

import { BrandHeader } from '@/components/payment/BrandHeader';

interface LegalDocumentShellProps {
  src: string;
  title: string;
}

export function LegalDocumentShell({ src, title }: LegalDocumentShellProps) {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950 flex flex-col items-center px-4 py-10">
      <div className="w-full max-w-3xl">
        <BrandHeader />
        <main className="bg-white dark:bg-gray-900 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 overflow-hidden">
          <iframe src={src} title={title} className="w-full h-[75vh] min-h-[500px] border-0" />
        </main>
      </div>
    </div>
  );
}
